module.exports = __webpack_public_path__ + "img/1-en.39215826.jpg";